export class TipoImprodutividade {
    Id: number = 0;
    Descricao:string = "";
    Codigo: number = 0;
}
